import React, { createContext, useState, useContext } from 'react';

export const PasswordResetContext = createContext();

export const PasswordResetProvider = ({ children }) => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');

  return (
    <PasswordResetContext.Provider value={{ email, otp, setEmail, setOtp }}>
      {children}
    </PasswordResetContext.Provider>
  );
};

export const usePasswordResetContext = () => useContext(PasswordResetContext);